import controller from './sign-up.controller';
import template from './sign-up.pug';

const SignUpComponent = {
  template,
  controller,
};

export default SignUpComponent;



// WEBPACK FOOTER //
// ./client/app/oauth/sign-up/sign-up.component.js